import L from 'leaflet';
import { updateUrlFromMapState } from '../map/urlState';
import { BaseLayers } from '../map/layers';
import { Overlays } from '../map/overlays';

export function initTrainingPanel(
    map: L.Map,
    baseLayers: BaseLayers,
    overlays: Overlays,
    mapFilterInput: HTMLInputElement
) {
    // 1. Inject HTML
    const panelHtml = `
<div id="training-panel" style="display:none;">
    <h3>Training Mode</h3>
    <div style="border:1px solid #333; border-radius:8px; padding:1em;">
        <p>You are seeing a restricted data set.</p>
        <p>Click the 'Exit' button to exit training mode, or click 'Cancel' to close this window and continue in training mode.</p>
    </div>
    <div style="margin-top:1em;">
        <button id="exit-training-btn">Exit</button>
        <button id="cancel-training-btn">Cancel</button>
    </div>
</div>
    `;

    // Append to body instead of #app to avoid overflow/z-index issues
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = panelHtml;
    document.body.appendChild(tempDiv.firstElementChild!);

    // 2. Get References
    const trainingPanel = document.getElementById('training-panel')!;
    const exitBtn = document.getElementById('exit-training-btn')!;
    const cancelBtn = document.getElementById('cancel-training-btn')!;

    // 3. Define Logic
    function openPanel() {
        trainingPanel.style.display = 'block';
    }

    // 4. Attach Listeners
    map.getContainer().addEventListener('open-training-panel', () => {
        openPanel();
    });

    cancelBtn.addEventListener('click', () => {
        trainingPanel.style.display = 'none';
    });

    exitBtn.addEventListener('click', () => {
        // Remove unit and level from URL
        const currentFilter = mapFilterInput.value;
        
        updateUrlFromMapState(map, baseLayers, overlays, currentFilter, '', '');
        
        // Reload the page to apply the clean state
        window.location.reload();
    });
}
